"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const certifications = [{
  id: 1,
  text: "Certificat en réflexologie plantaire – Réflexe Santé, Morges (en cours)"
}, {
  id: 2,
  text: "Certification Accompagnante Postnatale Le Mois d’Or (en cours)"
}, {
  id: 3,
  text: "Certification « Newborn Care Specialist » – Antenatal Training International"
}, {
  id: 4,
  text: "Formation sur le sommeil du nourrisson et du jeune enfant (0–5 ans) – Petit Monde"
}, {
  id: 5,
  text: "Formation « L’essentiel de l’allaitement » avec Carole Hervé, consultante IBCLC"
}, {
  id: 6,
  text: "Certification en psychologie de l’enfance – NCC Education, Royaume-Uni"
}, {
  id: 7,
  text: "Diplôme de Guide Montessori pour les enfants de 0 à 3 ans (AMI)"
}];
export default function Certifications() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}